import { AcceptedFileTypesConfig } from '@/shared/config';

export const hasAcceptedExtension = (
  file: File,
  config: AcceptedFileTypesConfig,
): boolean =>
  Object.entries(config).some(
    ([mimeType, extensions]) =>
      file.type === mimeType ||
      extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext.toLowerCase()),
      ),
  );
